import { useEffect, useState } from 'react';

import { useInView } from 'react-intersection-observer';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';
import { mediaMinWidth } from '@prose-ui/utils/media';

import Spacer from 'Components/Spacer';
import { Typography } from 'Components/Typography';
import { Video } from 'Components/Video';
import { YoutubeVideoButton } from 'Components/YoutubeVideoButton';

import { seeStoryContent } from 'assets/content/homeV2';
import seeStoryDesktop from 'assets/images/homeRevamp/image-see-story-desktop.jpg';
import seeStoryMobile from 'assets/images/homeRevamp/image-see-story-mobile.jpg';

import useResponsiveVariant from 'utils/useResponsiveVariant';

const Wrapper = styled.div`
  display: grid;
`;

const TitleAndButtonWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  grid-area: 1/-1;
  z-index: 1;
`;

const StyledTitle = styled(Typography)`
  color: white;
  text-align: center;
  font-size: 24px;
  font-family: ${theme.typography.fontFamily.body};
  ${mediaMinWidth('md')} {
    font-size: 40px;
  }
`;

const VideoContainer = styled.div`
  grid-area: 1/-1;
  border-radius: ${theme.radius.xs};
  overflow: hidden;
`;

type SeeTheStoryProps = {
  onOpenVideo: () => void;
};

export const SeeTheStory = ({ onOpenVideo }: SeeTheStoryProps) => {
  const { isMobile } = useResponsiveVariant();
  const { dataClick, dataFrom, title, buttonText, videoSrc, videoSrcMobile } = seeStoryContent;
  const [videoRef, videoInView] = useInView({ initialInView: false });
  const [ShouldPlayVideo, setShouldPlayVideo] = useState(false);
  useEffect(() => {
    if (videoInView) {
      setShouldPlayVideo(true);
    }
  }, []);

  return (
    <Wrapper ref={videoRef}>
      <VideoContainer>
        <Video
          autoplay
          forcePause={!ShouldPlayVideo}
          fullHeight
          fullWidth
          loop
          muted
          posterImage={isMobile ? seeStoryMobile : seeStoryDesktop}
          posterImageAlt="Prose made just for you campaign video"
          videoSource={isMobile ? videoSrcMobile : videoSrc}
        />
      </VideoContainer>
      <TitleAndButtonWrapper>
        <StyledTitle markupName="h2">{title}</StyledTitle>
        <Spacer size={isMobile ? 12 : 16} />
        <YoutubeVideoButton
          buttonText={buttonText}
          dataClick={dataClick}
          dataFrom={dataFrom}
          iconWhite
          onOpenVideo={onOpenVideo}
        />
      </TitleAndButtonWrapper>
    </Wrapper>
  );
};
